import React from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useApiMutation } from "src/hooks/useApiMutation";
export interface IDeleteTicketTarget {
	id: number;
	ticket_no?: string;
	visitor_name?: string;
	[key: string]: any;
}

interface Props {
	open: boolean;
	handleClose: () => void;
	ticket: IDeleteTicketTarget | null;
}

const DeleteTicketModal: React.FC<Props> = ({ open, handleClose, ticket }) => {
	const ticketId = ticket?.id;
	const { mutate: deleteTicket, isPending } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/v1/admin/visitor/ticket/${ticketId}`,
		invalidateQueries: [
			"AllVisitorTickets",
			"TicketStats",
			"Visitors",
			"VisitorDetails",
		],
	});

	const handleDelete = () => {
		if (!ticketId) return;
		deleteTicket(undefined as any, {
			onSuccess: () => {
				handleClose();
			},
		});
	};

	return (
		<Dialog
			open={open}
			onClose={isPending ? undefined : handleClose}
			disableEnforceFocus
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
				Delete Ticket
			</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ textAlign: "center", color: "text.secondary" }}>
					Are you sure you want to delete ticket{" "}
					<strong>{ticket?.ticket_no || `#${ticketId}`}</strong>
					{ticket?.visitor_name ? (
						<>
							{" "}
							for <strong>{ticket.visitor_name}</strong>
						</>
					) : null}
					? This action cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", pb: 2 }}>
				<Button
					onClick={handleClose}
					variant="outlined"
					disabled={isPending}
					sx={{
						borderColor: "grey.400",
						color: "grey.700",
						"&:hover": { backgroundColor: "grey.100" },
					}}
				>
					Cancel
				</Button>
				<LoadingButton
					onClick={handleDelete}
					color="error"
					variant="contained"
					loading={isPending}
				>
					<span>Delete</span>
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteTicketModal;
